export const iconFontAwesomeShapesLocationPin = (
	<i className="fa-solid fa-location-pin"></i>
);
